import { WidgetStreamMessagesState } from 'widgets/store/stream/WidgetStreamState';
import { ExpertiseResponseDataItem } from 'communication/types/expertise/ExpertiseResponse';

export interface ExpertiseStreamOrderDataItem
    extends ExpertiseResponseDataItem {
    date?: number;
    lastTradeTime?: number;
    startTime?: number;
    endTime?: number;
}

export interface ExpertiseStreamState extends WidgetStreamMessagesState {
    orderData: ExpertiseStreamOrderDataItem[];
}

export const initialExpertiseStreamState: ExpertiseStreamState = {
    orderData: [],
    messages: [],
};
